module.exports = __webpack_public_path__ + "static/img/new_program_01.1011b7a5.jpg";